import React from "react";
import SelectBox, { SelectBoxProps } from "./SelectBox";
import { useCountriesData } from "../../services/public.services";
import { useFormContext } from "react-hook-form";

interface StateSelectInputProps extends Omit<SelectBoxProps, "options"> {
  dependentFieldName?: string;
}

const DependentStateSelectInput: React.FC<StateSelectInputProps> = ({ dependentFieldName, ...selectBoxProps }) => {
  const { data, isLoading, error } = useCountriesData();
  const { getValues } = useFormContext();
  let stateOptions: { label: string; value: string }[] = [];

  if (dependentFieldName && data && Array.isArray(data.Countries)) {
    const countryName = getValues(dependentFieldName);
    const country = data?.Countries?.find((country: any) => country.CountryName?.toLowerCase() === countryName?.toLowerCase());
    if (country && Array.isArray(country.States)) {
      stateOptions = country.States.map((state: any) => ({
        label: state.StateName,
        value: state.StateName,
      }));
    }
  }

  return (
    <SelectBox
      options={stateOptions}
      loading={isLoading}
      errorText={error ? "Failed to load states options" : ""}
      {...selectBoxProps}
      showSearch
      disabled={!dependentFieldName || selectBoxProps.disabled}
    />
  );
};

export default DependentStateSelectInput;
